// extracted by mini-css-extract-plugin
module.exports = {"dots":"styles-module__dots___3d_9v","active":"styles-module__active___1FJrB","tooltip":"styles-module__tooltip___3IYz8","tooltipItem":"styles-module__tooltipItem___2zCwa"};